<template>
  <div class="dp-grid">
    <div v-for="d in paddedDates" :key="`p-${d}`"></div>
    <div v-for="date in dates" :key="date.day" class="text-center" :class="date.classes">
      <div class="widen-click-area-10px cursor-pointer" @click="$emit('click', date.mmDate)">
        {{ date.day }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['month', 'value'],
  inject: {
    supplier: {
      default: () => ({
        availableDays: ['0', '1', '2', '3', '4', '5', '6']
      })
    }
  },
  computed: {
    dayPattern () {
      if (this.supplier && this.supplier.availableDays && this.supplier.availableDays.length) {
        return this.supplier.availableDays
      }

      return ['0', '1', '2', '3', '4', '5', '6']
    },
    dates () {
      const today = moment()
      const current = this.month.clone()
      let startOfThisMonth = current.clone().startOf('month')
      const endOfNextMonth = current.clone().endOf('month')

      const dates = []
      let cursor = startOfThisMonth

      while (startOfThisMonth.isBefore(endOfNextMonth)) {
        const dayOfWeek = (cursor.isoWeekday() - 1).toString()

        const isDisabled = today.isAfter(cursor, 'day') ||
          this.dayPattern.includes(dayOfWeek) === false

        dates.push({
          year: cursor.year(),
          month: cursor.month(),
          day: cursor.date(),
          mmDate: cursor.clone(),
          classes: {
            'dp-date-cell': true,
            'dp-date--disabled': isDisabled,
            'dp-date--selected': this.checkIfDateIsSelected(cursor)
          }
        })

        cursor = cursor.add(1, 'days')
      }

      return dates
    },
    paddedDates () {
      const current = this.month.clone()
      const startOfThisMonth = current.clone().startOf('month')
      const dayOfWeek = startOfThisMonth.isoWeekday()

      const result = []
      for (let i = 0; i < dayOfWeek - 1; ++i) {
        result.push(i)
      }

      return result
    }
  },
  methods: {
    checkIfDateIsSelected (date) {
      if (this.value && this.value.isSame(date, 'day')) {
        return true
      }

      return false
    }
  }
}
</script>